export const attachmentMap: { [key: string]: string } = {
    'SCHOOL_ATTESTATION': 'schoolAttestation',
    'IDENTITY': 'identity',
    'VISA': 'visa',
    'PARENTAL_AUTHORIZATION': 'parentalAuthorization',
    'RESOURCE_CERTIFICATE': 'resourceCertificate',
    'CIVIL_STATUS': 'civilStatus',
    'CIVIL_STATUS_TRANSLATION': 'civilStatusTranslation',
    'RESIDENCE_PERMIT': 'residencePermit',
    'BANK_DETAILS': 'bankDetails',
    'BANK_DETAILS_DELEGATE': 'bankDetailsDelegate',
    'FORM_S1': 'formS1',
    'FORM_130_04': 'form13004',
    'FORM_SE401_Q102BIS': 'formSE401Q102BIS',
    'FORM_SE_401_Q106': 'formSE401Q106'
};

export const pdfOnlyAttachments = ['IDENTITY', 'CIVIL_STATUS', 'CIVIL_STATUS_TRANSLATION'];